"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarHome = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const AuthContext_1 = require("../../../hooks/auth/context/AuthContext");
const navBarHome_module_scss_1 = __importDefault(require("./navBarHome.module.scss"));
const NavBarHome = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { userInfo } = (0, AuthContext_1.useAuth)();
    return ((0, jsx_runtime_1.jsx)("div", { className: navBarHome_module_scss_1.default.container, children: (0, jsx_runtime_1.jsxs)("div", { className: navBarHome_module_scss_1.default.headerLeft, children: [(0, jsx_runtime_1.jsx)("span", { className: navBarHome_module_scss_1.default.greeting, children: t('welcome') || 'Welcome back' }), (0, jsx_runtime_1.jsx)("h1", { className: navBarHome_module_scss_1.default.title, children: userInfo?.username || 'Home' })] }) }));
};
exports.NavBarHome = NavBarHome;
